export default __webpack_public_path__ + "assets/0e6a1127e213591ce2c5a3198d1fe386.svg";